(function () {
  'use strict';
  if (window.AmadaCatalog) return;
  var initialized = new WeakSet();
  function scopeOf(node) {
    return node.closest('[data-amada-quickview-modals], [data-amada-drawer="amada-quickview"]') ? 'qv' : 'pdp';
  }
  function update(node, id) {
    var rows = node.querySelector('[data-amada-catalog-rows]');
    if (!rows) return;
    var template = Array.from(node.querySelectorAll('template[data-amada-catalog-variant]')).find(function (item) {
      return id != null && item.dataset.amadaCatalogVariant === String(id);
    });
    rows.replaceChildren();
    if (template) rows.appendChild(template.content.cloneNode(true));
    node.hidden = !rows.children.length;
  }
  function init(root) {
    (root || document).querySelectorAll('[data-amada-catalog-specs]').forEach(function (node) {
      if (initialized.has(node)) return;
      initialized.add(node);
      var input = scopeOf(node) === 'qv' ? document.querySelector('[data-amada-qv-variant-id]') : null;
      update(node, input ? input.value : node.dataset.initialVariant);
    });
  }
  document.addEventListener('product:variant-change', function (event) {
    var detail = event.detail || {};
    var scope = detail.amadaScope === 'qv' ? 'qv' : 'pdp';
    document.querySelectorAll('[data-amada-catalog-specs]').forEach(function (node) {
      if (scopeOf(node) === scope) update(node, detail.variant && detail.variant.id);
    });
  });
  window.AmadaCatalog = { init: init };
  function start() {
    init(document);
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-amada-catalog-specs]') || node.querySelector('[data-amada-catalog-specs]'));
        });
      })) init(document);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
